import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const NotFound = () => {
  const sectionVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  const contentVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 1 } },
  };

  const childVariants = {
    animate: {
      y: [0, -20, 0],
      transition: { duration: 3, repeat: Infinity, ease: "easeInOut" },
    },
  };

  return (
    <section className="relative bg-cream text-navy w-full min-h-screen flex items-center justify-center overflow-x-hidden overflow-y-hidden py-4 sm:py-6 md:py-8">
      <motion.div
        className="text-center z-10 px-4 sm:px-6 md:px-8 w-full max-w-[90vw] sm:max-w-3xl md:max-w-4xl lg:max-w-5xl xl:max-w-5xl 2xl:max-w-6xl"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={sectionVariants}
      >
        <motion.h2
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold uppercase tracking-tight text-primary drop-shadow-2xl"
          style={{ fontFamily: "Baloo 2", fontWeight: 800 }}
          initial={{ scale: 0.5 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 1, type: "spring" }}
        >
          Stratil si sa?
        </motion.h2>
        <motion.div
          className="mt-4 sm:mt-6 md:mt-8 lg:mt-10 xl:mt-10 2xl:mt-12 relative"
          variants={contentVariants}
        >
          <motion.div className="bg-white p-4 sm:p-6 md:p-8 lg:p-10 xl:p-10 2xl:p-12 rounded-3xl shadow-2xl border-4 border-primary w-full max-w-[95%] sm:max-w-[90%] md:max-w-[85%] lg:max-w-[80%] xl:max-w-[75%] 2xl:max-w-4xl mx-auto relative">
            <motion.div
              className="absolute -top-4 sm:-top-6 md:-top-6 lg:-left-8 xl:-left-8 2xl:-left-8 w-8 sm:w-12 md:w-12 lg:w-14 xl:w-14 2xl:w-16 h-8 sm:h-12 md:h-12 lg:h-14 xl:h-14 2xl:h-16 bg-primary rounded-full"
              animate={{ rotate: 360 }}
              transition={{
                duration: 10,
                repeat: Infinity,
                ease: "linear",
              }}
            />
            <motion.div
              className="absolute -bottom-4 sm:-bottom-6 md:-bottom-6 lg:-bottom-8 xl:-bottom-8 2xl:-bottom-8 -right-4 sm:-right-6 md:-right-6 lg:-right-8 xl:-right-8 2xl:-right-8 w-8 sm:w-12 md:w-12 lg:w-14 xl:w-14 2xl:w-16 h-8 sm:h-12 md:h-12 lg:h-14 xl:h-14 2xl:h-16 bg-secondary rounded-full"
              animate={{ rotate: -360 }}
              transition={{
                duration: 10,
                repeat: Infinity,
                ease: "linear",
              }}
            />
            <motion.p
              className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-bold text-navy"
              style={{ fontFamily: "Baloo 2", fontWeight: 800 }}
            >
              Oops!
            </motion.p>
            <motion.p
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-primary mt-2"
              style={{ fontFamily: "Baloo 2", fontWeight: 600 }}
            >
              Chyba 404
            </motion.p>
            <motion.div className="mt-6">
              <Link to="/">
                <motion.button
                  className="bg-navy text-cream px-12 py-4 rounded-full text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold hover:bg-primary transition-all duration-300"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                >
                  Späť
                </motion.button>
              </Link>
            </motion.div>
          </motion.div>
        </motion.div>
      </motion.div>

      {/* Decorative Elements */}
      <motion.img
        src="/assets/ruksak.svg"
        alt="Backpacks"
        className="absolute top-6 sm:top-8 md:top-10 lg:top-12 xl:top-14 2xl:top-16 left-4 sm:left-8 md:left-12 lg:left-16 xl:left-16 2xl:left-20 h-24 sm:h-32 md:h-40 lg:h-48 xl:h-56 2xl:h-64 drop-shadow-xl"
        variants={childVariants}
        animate="animate"
      />
      <motion.img
        src="/assets/lopty.svg"
        alt="Balls"
        className="absolute top-6 sm:top-8 md:top-10 lg:top-12 xl:top-14 2xl:top-16 right-4 sm:right-8 md:right-12 lg:right-16 xl:right-16 2xl:right-20 h-24 sm:h-32 md:h-40 lg:h-48 xl:h-56 2xl:h-64 drop-shadow-xl"
        variants={childVariants}
        animate="animate"
      />
      <motion.div
        className="absolute top-4 sm:top-6 md:top-8 lg:top-8 xl:top-10 2xl:top-10 left-4 sm:left-6 md:left-8 lg:left-10 xl:left-10 2xl:left-10 w-6 sm:w-8 md:w-10 lg:w-10 xl:w-12 2xl:w-12 h-6 sm:h-8 md:h-10 lg:h-10 xl:h-12 2xl:h-12 bg-primary/30 rounded-full"
        animate={{ scale: [1, 1.5, 1], opacity: [0.3, 0.6, 0.3] }}
        transition={{ duration: 3, repeat: Infinity }}
      />
      <motion.div
        className="absolute bottom-4 sm:bottom-6 md:bottom-8 lg:bottom-8 xl:bottom-10 2xl:bottom-10 right-4 sm:right-6 md:right-8 lg:right-10 xl:right-10 2xl:right-10 w-6 sm:w-8 md:w-10 lg:w-10 xl:w-12 2xl:w-12 h-6 sm:h-8 md:h-10 lg:h-10 xl:h-12 2xl:h-12 bg-secondary/30 rounded-full"
        animate={{ scale: [1, 1.5, 1], opacity: [0.3, 0.6, 0.3] }}
        transition={{ duration: 3, repeat: Infinity }}
      />
      <motion.img
        src="/assets/dievca_half.svg"
        alt="Character 1"
        className="absolute bottom-0 left-4 sm:left-8 md:left-12 lg:left-16 xl:left-16 2xl:left-20 h-48 sm:h-64 md:h-72 lg:h-80 xl:h-96 2xl:h-[28rem] drop-shadow-xl"
        variants={childVariants}
        animate="animate"
      />
      <motion.img
        src="/assets/superman-01.svg"
        alt="Character 2"
        className="absolute bottom-0 right-4 sm:right-8 md:right-12 lg:right-16 xl:right-16 2xl:right-20 h-48 sm:h-64 md:h-72 lg:h-80 xl:h-96 2xl:h-[28rem] drop-shadow-xl"
        variants={childVariants}
        animate="animate"
      />
    </section>
  );
};

export default NotFound;
